import axios from 'axios';
import { apiURL } from './apiURL';

const privateAPI = axios.create({
  baseURL: apiURL,
  headers: {
    'Content-Type': 'application/json',
  },
});

privateAPI.interceptors.request.use(
  (config) => {
    // console.log(
    // 	"\x1b[36m%s\x1b[0m",
    // 	`${config.method?.toUpperCase() || ""} - ${config.baseURL || ""}/${config.url || ""}`
    // );

    let token: string | null = null;

    if (typeof localStorage !== 'undefined') {
      token = localStorage.getItem('accessToken');
    }
    if (token && config.headers) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      delete privateAPI.defaults.headers.common.Authorization;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

// AJOUT du 28/04/2026 : intercepteur de réponse pour gérer les tokens expirés
privateAPI.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const isLoginPage = window.location.pathname.includes('/authentication/login');
      const excludedRoutes = ['/auth/profile', '/auth/admin', '/user/notification/admin'];
      const isExcludedRoute = excludedRoutes.some(route => error.config?.url === route);
      const token = typeof localStorage !== 'undefined'
        ? localStorage.getItem('accessToken')
        : null;

      if (!isLoginPage && !isExcludedRoute && token) {
        localStorage.removeItem('accessToken');
        window.location.href = '/authentication/login';
      }
    }
    return Promise.reject(error);
  },
);

export default privateAPI;
